import { getAPIUrl } from '../helpers/App';

export const APIgetAppChangelog = () => (
  window.axios.get(getAPIUrl('/admin/changelog'))
    .then(response => (response))
);

export const APIgetAdminOverview = () => (
  window.axios.get(getAPIUrl('/admin/overview'))
    .then(response => (response))
);

export const APIgetAdminOnlineUsers = (params) => (
  window.axios.get(getAPIUrl('/admin/online'), { params })
    .then(response => (response))
);
